import { CLIENT_NAME, HOSTNAME } from '@/utils'
import type { TypeLang } from '@/schema'
import { buildUrl } from './_url'

const ADDRESS_SPAIN = {
  '@type': 'PostalAddress',
  'streetAddress': 'Autovía A-62 Km 148 El Montico',
  'addressLocality': 'Tordesillas',
  'addressRegion': 'Valladolid',
  'postalCode': '47100',
  'addressCountry': 'ES'
}

const ADDRESS_CHINA = {
  '@type': 'PostalAddress',
  'streetAddress': 'B105-108 & B203 of Chuangjin Center, No.8 Baihesha Road, Liwan District',
  'addressLocality': 'Guangzhou',
  'postalCode': '510000',
  'addressCountry': 'CN'
}

const CONTACT_POINT_SPAIN = {
  '@type': 'ContactPoint',
  'telephone': '+34-983-222-244',
  'email': 'aybhislabor@aybhislabor.com',
  'contactType': 'customer service',
  'areaServed': 'Europe',
  'availableLanguage': ['Spanish', 'English']
}

const CONTACT_POINT_CHINA = {
  '@type': 'ContactPoint',
  'telephone': '+86-20-8421-4549',
  'email': 'sales@aybcose.com',
  'contactType': 'sales',
  'areaServed': 'Asia',
  'availableLanguage': ['English', 'Chinese']
}

const SAME_AS = [
  'https://www.facebook.com/aybhislabor/',
  'https://www.linkedin.com/company/ayb-hislabor/',
  'https://www.instagram.com/aybhislabor/',
  'https://www.youtube.com/@aybhislabor8993'
]

const ORG_DESCRIPTION: Record<TypeLang, string> = {
  es: 'Empresa especializada en fabricación y distribución de fornituras para la moda. Productos para mercerías y confección.',
  en: 'Company specialized in the manufacture and distribution of haberdashery for fashion. Products for haberdasheries and clothing.'
}

type TypeOrganizationDepth = 'full' | 'brief'

export function buildOrganization(locale: TypeLang, depth: TypeOrganizationDepth = 'full') {
  const base = {
    '@type': 'Corporation',
    'name': CLIENT_NAME,
    'url': buildUrl(locale),
    'logo': {
      '@type': 'ImageObject',
      'url': `https://${HOSTNAME}/images/svg/logo.svg`
    },
    'foundingDate': '1986'
  }

  if (depth === 'brief') return base

  return {
    ...base,
    'description': ORG_DESCRIPTION[locale],
    'address': [ADDRESS_SPAIN, ADDRESS_CHINA],
    'contactPoint': [CONTACT_POINT_SPAIN, CONTACT_POINT_CHINA],
    'sameAs': SAME_AS,
    'numberOfEmployees': {
      '@type': 'QuantitativeValue',
      'minValue': 50
    }
  }
}
